
import React from 'react';
import { Link } from 'react-router-dom';
import {
  Button,
  NavItem,
  NavLink,
  Nav,
  Container,
  Row,
  Col,
  UncontrolledTooltip,
} from 'reactstrap';

export default function FullFooter() {
  return (
    <>
      <footer className="footer">
        <Container>
          <Row>
            <Col md="3">
              <img
                alt="cloud engineering logo"
                src={require("assets/img/cloud-engineer-logo.svg").default}
              />
            </Col>
            <Col md="3" xs="6">
              <Nav>
                <NavItem>
                  <NavLink href="//cloudengineer.global/">
                    Home
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink href="//cloudengineer.global/about/">
                    About
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink href="//cloudengineer.global/blog/">
                    Blog
                  </NavLink>
                </NavItem>
              </Nav>
            </Col>
            <Col md="3" xs="6">
              <Nav>
                <NavItem>
                  <NavLink
                    to="/"
                    tag={Link}
                  >
                    Contact
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    href="//cloudengineer.global/definitions/"
                  >
                    Definitions
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    href="//cloudengineer.global/projects/"
                  >
                    Projects
                  </NavLink>
                </NavItem>
              </Nav>
            </Col>
            <Col md="3">
              <h3 className="title">Follow me:</h3>
              <div className="btn-wrapper profile text-left">
                <Button
                  className="btn-icon btn-neutral btn-round btn-simple"
                  color="default"
                  href="https://github.com/jzj"
                  id="githubLink"
                  target="_blank"
                >
                  <i className="fab fa-github" />
                </Button>
                <UncontrolledTooltip delay={0} target="githubLink">
                  Github
                </UncontrolledTooltip>
                <Button
                  className="btn-icon btn-neutral btn-round btn-simple"
                  color="default"
                  href="https://gitlab.com/jzj"
                  id="gitlabLink"
                  target="_blank"
                >
                  <i className="fab fa-gitlab" />
                </Button>
                <UncontrolledTooltip delay={0} target="gitlabLink">
                  Gitlab
                </UncontrolledTooltip>
              </div>
            </Col>
          </Row>
        </Container>
      </footer>
    </>
  );
}
